<div class="loginContainerPage">
  <div fxLayout="column" fxLayoutAlign="center center" fxFill>
    <form (ngSubmit)="toAccess()" [formGroup]="loginForm">
      <mat-card class="ps-login-card">
        <mat-card-content>
          <div fxLayoutAlign="center center" class="ps-login-content-logo">
            <img src="{{env.storage_path+customSettings.logo}}" alt="">
          </div>
          <div class="ps-form-login-content">
            <app-form-login [loginData]="loginData" [hasAutoLogin]="hasAutoLogin"></app-form-login>
          </div>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
</div>
<div class="loginContainerPageBG" [ngClass]="{hasBackground: env.storage_path+customSettings.background}"
  [style.background-image]="'url('+env.storage_path+customSettings.background+')'" [style.height]="'100%'"></div>